import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/database';

import config from '../config';
import callRemote from '../utils/remote';

class Firebase {
  constructor() {
    app.initializeApp(config.firebase);
    this.auth = app.auth();
    this.storage = app.storage();
    this.firestore = app.firestore();

    // When running in headless Playwright (screenshot service), streaming XHR responses
    // are buffered by the CDP layer, causing onSnapshot to never fire. Force long-polling
    // to work around this. The screenshot service sets this flag via page.addInitScript()
    // before any page JS runs, so it is available here at initialization time.
    if (typeof window !== 'undefined' && localStorage.getItem('screenshotMode') === 'true') {
      this.firestore.settings({ experimentalForceLongPolling: true, merge: true });
    }

    this.rtdb = app.database();
    this.app = app;
  }

  signOut = () => this.auth.signOut();

  /**
   * Makes a remote call to Firebase Functions endpoints
   * @param {string} path - The endpoint path to call
   * @param {object|null} body - The request body (optional)
   * @param {object} request - The request configuration options
   * @param {boolean} bypassIdToken - When true, makes an unauthenticated call to the endpoint.
   *                                 IMPORTANT: This will only work for Firebase Functions that are
   *                                 explicitly configured to allow unauthenticated access.
   * @returns {Promise<Response>} The fetch response
   */

  remote = async (path, body = null, request = {}, bypassIdToken = false) => {
    // TODO: If this call happens on page-load, auth may not have
    // the currentUser's id token ready yet.  Should handle that case
    // by waiting for the currentUser to be populated with the
    // logged-in user.
    const idToken = bypassIdToken ? null : await this.auth.currentUser.getIdToken();
    return callRemote(idToken, path, body, request);
  };
}

export default Firebase;
